

























































































































































































import { AvisDePrelevementApi } from "../api/AvisDePrelevementApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import AvisDePrelevementListFilters from "./AvisDePrelevementListPartials/AvisDePrelevementListFilters.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import AvisDePrelevementModal from "./AvisDePrelevementModal.vue";
import { Routes } from "../utils/Routes";
import { AvisDePrelevement } from "../models/AvisDePrelevement";

export default {
    name: "AvisDePrelevementList",
    components: {
        ExportButton,
        Pagination,
        PerPage,
        AvisDePrelevementListFilters,
        AutoRefresh,
        AvisDePrelevementModal,
    },
    data() {
        return {
            avisDePrelevements: [],
            montantTotal: 0,
            AvisDePrelevementApi: new AvisDePrelevementApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            avisDePrelevementModal: {
                avisDePrelevementId: null,
                isNew: false,
                forceEditing: false,
            },
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "files",
                sort: this.sort,
            };

            params = _.assign(params, self.filters);
            self.loading = !hideLoading;

            return self.AvisDePrelevementApi.getAll(params)
                .then(function (response) {
                    let { data, metadata, paginator } = response;

                    self.avisDePrelevements = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;
                    self.montantTotal = metadata.montant_total;

                    return self.avisDePrelevements;
                })
                .catch(function (error) {
                    self.avisDePrelevements = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        getAvisDePrelevements() {
            return this.loadPage(this.currentPage);
        },
        refreshAvisDePrelevements() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.loadPage(1);
        },
        updateSort(sort): void {
            this.sort = sort;
            this.loadPage(1);
        },
        getExportParams() {
            return _.assign({ sort: this.sort }, this.filters);
        },
        editAvis(avis) {
            this.avisDePrelevementModal.isNew = false;
            this.avisDePrelevementModal.forceEditing = true;
            this.avisDePrelevementModal.avisDePrelevementId = avis.id;
        },
        onAvisDePrelevementModalClose() {
            this.avisDePrelevementModal.avisDePrelevementId = null;
            this.avisDePrelevementModal.forceEditing = false;
            this.avisDePrelevementModal.isNew = false;
            this.refreshAvisDePrelevements();
        },
        deleteAvis(avis) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cet avis de prélèvement&nbsp;?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.AvisDePrelevementApi.delete(avis.id, raison)
                    .then(function () {
                        self.getAvisDePrelevements();
                        swal(
                            "L'avis de prélèvement a bien été supprimé !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        roundAmount(amount) {
            return _.round(amount || 0, 2).toFixed(2);
        },
        onRowDblClick(avis, event) {
            if (event.target.closest("a, button, input")) {
                return;
            }
            this.editAvis(avis);
        },
        // UI
        addContactUrl(avis: AvisDePrelevement): string {
            if (avis.fournisseur_name) {
                return Routes.new_contact + "?nom=" + avis.fournisseur_name;
            }
        },
        showMailInfo() {
            swal({
                title: "Import de documents",
                text:
                    "Les avis de prélèvement doivent être transférés par mail à l'adresse <a href='mailto:" +
                    window.documentMail +
                    "'>" +
                    window.documentMail +
                    "</a>" +
                    "<br/>" +
                    "Format pdf uniquement, un avis par fichier, plusieurs avis dans le même mail possible.",
                type: "info",
                showCancelButton: false,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "OK",
            });
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
